import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ContestReport from './ContestReport';

// Публичная страница для экспорта отчетов конкурсов (без Layout и аутентификации)
// Доступна только локально (localhost) для использования через Puppeteer

const ContestReportExport: React.FC = () => {
  const { contestId } = useParams<{ contestId: string }>();
  const [isLocalhost, setIsLocalhost] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Проверяем, что мы на localhost или на рабочем домене
    const hostname = window.location.hostname;
    const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === 'ttm.bogslevel.com';
    setIsLocalhost(isLocal);
    setMounted(true);
  }, []);

  // Если не localhost, показываем ошибку
  if (!isLocalhost && mounted) {
    return (
      <div style={{ padding: '20px', background: 'white', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: 'red', fontSize: '18px' }}>Доступ запрещен. Эта страница доступна только локально.</div>
      </div>
    );
  }

  if (!contestId || !mounted) {
    return (
      <div style={{ padding: '20px', background: 'white', minHeight: '100vh' }}>
        <div>Загрузка...</div>
      </div>
    );
  }

  // Убираем padding для экспорта - Puppeteer обрежет до контента
  return (
    <div style={{ padding: '0', margin: '0', background: 'white' }}>
      <ContestReport contestId={contestId} isExportMode={true} />
    </div>
  );
};

export default ContestReportExport;

